module.exports = __webpack_public_path__ + "static/media/AuxInput.f7cffd58.svg";